import { render, staticRenderFns } from "./TeamsStats.vue?vue&type=template&id=4ed0eb3d&"
import script from "./TeamsStats.vue?vue&type=script&lang=js&"
export * from "./TeamsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports